import React, { useState } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  '@keyframes mainanimation': {
    from: {
      transform: 'scale(0)',
      opacity: 0,
    },
    to: {
      transform: 'scale(1.5)',
      opacity: 1,
    },
  },

  '@keyframes upanumation': {
    from: {
      transform: 'scale(2) rotate(30deg) translate(20px, -20px)',
      opacity: 0,
    },
    to: {
      transform: 'scale(1.0) rotate(0) translate(0, 0)',
      opacity: 1,
    },
  },

  '@keyframes bottomanimation': {
    from: {
      transform: 'scale(2)  rotate(30deg) translate(-20px, 20px)',
      opacity: 0,
    },
    to: {
      transform: 'scale(1.0) rotate(0deg) translate(0, 0)',
      opacity: 1,
    },
  },

  '@keyframes textanimation': {
    '0%': {
      transform: 'translate(0, 50px)',
      zIndex: -1,
      opacity: 0,
    },
    '80%': {
      transform: 'translate(0, 50px)',
      zIndex: -1,
      opacity: 0,
    },
    '100%': {
      transform: 'translate(0, 0)',
      zIndex: 21,
      opacity: 1,
    },
  },

  '@keyframes hovericon': {
    from: {
      transform: 'scale(1)',
    },
    to: {
      transform: 'scale(1.25)',
    },
  },

  '@keyframes nothovericon': {
    from: {
      transform: 'scale(1.25)',
    },
    to: {
      transform: 'scale(1)',
    },
  },

  '@keyframes uphoveranimation': {
    from: {
      transform: 'rotate(0)',
    },
    to: {
      transform: 'rotate(180deg)',
    },
  },

  '@keyframes notuphoveranimation': {
    from: {
      transform: 'scale(1.25) rotate(180deg)',
    },
    to: {
      transform: 'scale(1) rotate(0deg)',
    },
  },

  '@keyframes bottomhoveranimation': {
    from: {
      transform: 'rotate(0)',
    },
    to: {
      transform: 'rotate(180deg)',
    },
  },

  '@keyframes notbottomhoveranimation': {
    from: {
      transform: 'scale(1.25) rotate(180deg)',
    },
    to: {
      transform: 'scale(1) rotate(0)',
    },
  },

  content: {
    position: 'absolute',
    left: '50%',
    top: '50%',
    zIndex: 20,
    cursor: 'pointer',
  },

  contentAnimations: {
    '&:hover': {
      animation: '$hovericon 0.3s linear',
      transform: 'scale(1.25)',
      '& .up-arch': {
        animation: '$uphoveranimation 0.3s linear',
        transformOrigin: '0px 40px',
        transform: 'rotate(190deg)',
        top: 10,
      },
      '& .bottom-arch': {
        animation: '$bottomhoveranimation 0.3s linear',
        transformOrigin: '40px -20px',
        transform: 'rotate(190deg)',
        top: 50,
      },
    },
    '&:not(:hover)': {
      animation: '$nothovericon 0.3s linear',
      '& .up-arch': {
        animation: '$notuphoveranimation 0.3s linear',
        transformOrigin: '0px 40px',
        transform: 'rotate(0deg)',
      },
      '& .bottom-arch': {
        animation: '$notbottomhoveranimation 0.3s linear',
        transformOrigin: '40px -20px',
        transform: 'rotate(0deg)',
      },
    },
  },

  icon: {
    height: '80px',
    width: '80px',
    position: 'relative',
    margin: '0 auto',
    padding: 0,
  },

  main: {
    height: '39px',
    width: '39px',
    position: 'absolute',
    top: '20px',
    left: '20px',
    margin: 0,
    padding: 0,
    animation: '$mainanimation 1s linear',
    transform: 'scale(1.5)',
  },

  up: {
    height: '20px',
    width: '39px',
    position: 'absolute',
    right: 5,
    top: -5,
    margin: 0,
    padding: 0,
    animation: '$upanumation 1s linear',
  },
  bottom: {
    position: 'absolute',
    height: '20px',
    width: '39px',
    bottom: -5,
    left: 5,
    margin: 0,
    padding: 0,
    animation: '$bottomanimation 1s linear',
    '& img': {
      transform: 'rotate(180deg)',
    },
  },
  text: {
    animation: '$textanimation 1s linear',
    fontFamily: 'Roboto',
    fontWeight: 'bold',
    fontSize: 20,
    color: '#981248',
    textAlign: 'center',
    marginTop: 20,
  },
}));

/**
 * Component to display the animated icon
 *
 * @param {Object} props
 */
const MainIconAnimated = props => {
  const { text, svgUrl, onClick, className, ...rest } = props;

  const classes = useStyles();

  const [mouseEntered, setMouseEntered] = useState(false);

  return (
    <div
      onMouseEnter={() => setMouseEntered(true)}
      className={clsx({
        [classes.content]: true,
        [classes.contentAnimations]: mouseEntered,
        [className]: !!className,
      })}
      onClick={() => onClick && onClick({ text, svgUrl, ...rest })}
    >
      <div className={clsx(classes.icon)}>
        <div className={clsx(classes.main)}>
          <img alt="icon preview" src={svgUrl} />
        </div>
        <div className={clsx(classes.up, 'up-arch')}>
          <img alt="icon preview" src="assets/icons/arch.svg" />
        </div>
        <div className={clsx(classes.bottom, 'bottom-arch')}>
          <img alt="icon preview" src="assets/icons/arch.svg" />
        </div>
      </div>
      <div className={classes.text}>{text}</div>
    </div>
  );
};

MainIconAnimated.defaultProps = {};

MainIconAnimated.propTypes = {
  /**
   * External classes
   */
  className: PropTypes.string,
  svgUrl: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  onClick: PropTypes.func,
};

export default MainIconAnimated;
